import React from 'react';

const PrivacyPolicy = () => (
  <>
    <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #002868, #1a56db)' }}>
      <div className="container py-4">
        <h1 className="fw-bold">Privacy Policy</h1>
        <p className="lead" style={{ color: '#cbd5e1' }}>Last updated: January 2025</p>
      </div>
    </section>

    <section className="py-5 bg-white">
      <div className="container py-4" style={{ maxWidth: 800 }}>
        {[
          {
            title: '1. Information We Collect',
            content: 'We collect information you provide directly to us, such as your name, email address, phone number, and any other information you choose to provide when contacting us or using our services.',
          },
          {
            title: '2. How We Use Your Information',
            content: 'We use the information we collect to provide, maintain, and improve our services, respond to your inquiries, send you technical notices and support messages, and communicate with you about products, services, and events.',
          },
          {
            title: '3. Information Sharing',
            content: 'We do not sell, trade, or otherwise transfer your personally identifiable information to outside parties without your consent, except to trusted third parties who assist us in operating our website and conducting our business.',
          },
          {
            title: '4. Data Security',
            content: 'We implement a variety of security measures to maintain the safety of your personal information. Your personal information is contained behind secured networks and is only accessible by a limited number of persons.',
          },
          {
            title: '5. Cookies',
            content: 'Our website may use cookies to enhance your experience. You can choose to disable cookies through your browser settings, though this may affect some functionality of our website.',
          },
          {
            title: '6. Third-Party Links',
            content: 'Our website may contain links to third-party websites. We have no responsibility for the content or privacy practices of those sites and encourage you to review their privacy policies.',
          },
          {
            title: '7. Contact Us',
            content: 'If you have any questions about this Privacy Policy, please contact us at support@egbsystems.com or call 203 653 2741.',
          },
        ].map((section, i) => (
          <div key={i} className="mb-4">
            <h5 className="fw-bold" style={{ color: '#1a56db' }}>{section.title}</h5>
            <p className="text-muted" style={{ lineHeight: 1.8 }}>{section.content}</p>
          </div>
        ))}
      </div>
    </section>
  </>
);

export default PrivacyPolicy;
